import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { StyledEngineProvider } from "@mui/material";

import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "./firebase/firebase";

// Import the functions you need from the SDKs you need
import { onAuthStateChanged2 } from "./firebase/firebase";
import {
  login,
  logout,
  selectRoleObj,
  selectUsername,
  setGrp,
  setRoleObj,
} from "./features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { getRole } from "./services/role/roleApi";
// import { pdfjs } from "react-pdf";
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.js",
//   import.meta.url,
// ).toString();
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const AuthProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged2((user) => {
      const handleUser = async () => {
        if (user) {
          // const profile = await fetchUserProfile(user.uid);
          dispatch(login({ username: user.email, token: user.uid }));
          // dispatch(setGrp({grp: process.env.REACT_APP_GRP}));
          // console.log(process.env.REACT_APP_GRP)
        } else {
          dispatch(logout());
        }

        setPending(false);
      };

      handleUser();
    });

    return () => unsubscribe();
  }, [dispatch]);

  if (pending) {
    return <>Loading...</>;
  }

  return <>{children}</>;
};

root.render(
  <Provider store={store}>
    <AuthProvider>
      <BrowserRouter
        future={{
          v7_fetcherPersist: true,
          v7_normalizeFormMethod: true,
          v7_partialHydration: true,
          v7_relativeSplatPath: true,
          v7_skipActionErrorRevalidation: true,
          v7_startTransition: true,
        }}
      >
        <StyledEngineProvider injectFirst>
          <App />
        </StyledEngineProvider>
      </BrowserRouter>
    </AuthProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
